import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Splash from "./routes/Splash";
import NewSplash from "./routes/NewSplash";
import Login from "./routes/Login";
import SignUp from "./routes/SignUp";
import Home from "./routes/Home";
import Profile from "./routes/Profile";
import Radio from "./routes/Radio";
import Circle from "./routes/Circle";
import MountainRetreat2025 from "./routes/MountainRetreat2025";
import Retreat from "./routes/Retreat";
import ResetPassword from "./routes/ResetPassword";
import "./App.css";
import FsmrStudentInfo2025 from "./routes/FsmrStudentInfo2025";
import Blogs from "./routes/Blog";
import DetailBlog from "./routes/DetailBlog";

function RedirectOldPath() {
  const location = useLocation();
  const path = location.pathname;

  // Ambil slug dari path (tanpa "/")
  const slug = path.startsWith("/") ? path.slice(1) : path;

  return <Navigate to={`/blog/${slug}`} replace />;
}

function App() {
  const [email, setEmail] = useState(localStorage.getItem("email"));

  useEffect(() => {
    const handleStorageChange = () => {
      setEmail(localStorage.getItem("email"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const whiteListedPaths = [
    "memberships",
    "retreats",
    "mastery",
    "about",
    "login",
    "signup",
    "reset-password",
    "courses",
    "profile",
    "tracks",
    "circle",
    "blog",
    "mountain-retreat-2025",
    "fsmr-student-info-2025",
    "fiddle-school"
  ];

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/memberships" element={<Splash page="memberships" />} />
        <Route path="/fiddle-school" element={<Splash page="fiddle-school" />} />
        <Route path="/mastery" element={<Splash page="mastery" />} />
        <Route path="/retreats" element={!email || email === "null" ? <Splash page="retreat" /> : <Retreat />} />
        <Route path="/about" element={<Splash page="about" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/courses" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/mountain-retreat-2025" element={!email || email === "null" ? <Splash page="mountain-retreat-2025" /> : <MountainRetreat2025 />} />
        <Route path="/fsmr-student-info-2025" element={!email || email === "null" ? <NewSplash /> : <FsmrStudentInfo2025 />} />
        <Route path="/tracks" element={<Radio />} />
        <Route path="/circle" element={<Circle />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/blog/:articleHandle" element={<DetailBlog />} />

        {/* Redirect path selain yang di-whitelist ke /blog/{slug} */}
        <Route
          path="*"
          element={
            (() => {
              const currentPath = window.location.pathname.replace(/^\/+/, "");
              const isWhitelisted = whiteListedPaths.includes(currentPath.split("/")[0]);
              return isWhitelisted ? <Navigate to="/" /> : <RedirectOldPath />;
            })()
          }
        />
      </Routes>
    </div>
  );
}

export default App;
